module.exports = __webpack_public_path__ + "static/media/cross-around.f0873574.svg";